import React from 'react'
import InlineSVG from 'svg-inline-react'

const ieIMRD = props => (
  <InlineSVG
    style={{ height: '55%', width: 100, marginLeft: -20, marginTop: -7 }}
    src={`<svg viewBox="0 0 155.06 44.93" >
    <path
      d="M0 44.93V0h9.06v44.93zM57.2 0H66v44.93h-8.86v-29L46.51 36.44h-8.12l-10.7-20.52v29h-8.81V0h8.81l14.79 28.19zM98.93 44.93l-9.76-16.86h-4.66v16.86h-8.74V0H93q7.3 0 11.23 3.84a13.7 13.7 0 0 1 3.94 10.26q0 10.5-9.88 13.15l11 17.68zM84.51 7.55v13.28h7.24q7.31 0 7.3-6.8a6.27 6.27 0 0 0-1.82-4.75 7.52 7.52 0 0 0-5.35-1.73zM116.11 44.93V0h17.18A22 22 0 0 1 145 3.08a19.82 19.82 0 0 1 7.55 8.12 24.41 24.41 0 0 1 2.52 11.08 23.35 23.35 0 0 1-5.85 16.08q-5.85 6.57-16 6.57zm9.06-7.55h7.42a12.35 12.35 0 0 0 9.76-4.25 15.91 15.91 0 0 0 3.71-10.85 15.82 15.82 0 0 0-3.56-10.45 11.83 11.83 0 0 0-9.59-4.28h-7.74z"
      fill=${props.color ? props.color : '#fff'}
    />
  </svg>`}
  />
)

const IMRD = props => (
  <svg viewBox="0 0 155.06 44.93" {...props}>
    <path
      d="M0 44.93V0h9.06v44.93zM57.2 0H66v44.93h-8.86v-29L46.51 36.44h-8.12l-10.7-20.52v29h-8.81V0h8.81l14.79 28.19zM98.93 44.93l-9.76-16.86h-4.66v16.86h-8.74V0H93q7.3 0 11.23 3.84a13.7 13.7 0 0 1 3.94 10.26q0 10.5-9.88 13.15l11 17.68zM84.51 7.55v13.28h7.24q7.31 0 7.3-6.8a6.27 6.27 0 0 0-1.82-4.75 7.52 7.52 0 0 0-5.35-1.73zM116.11 44.93V0h17.18A22 22 0 0 1 145 3.08a19.82 19.82 0 0 1 7.55 8.12 24.41 24.41 0 0 1 2.52 11.08 23.35 23.35 0 0 1-5.85 16.08q-5.85 6.57-16 6.57zm9.06-7.55h7.42a12.35 12.35 0 0 0 9.76-4.25 15.91 15.91 0 0 0 3.71-10.85 15.82 15.82 0 0 0-3.56-10.45 11.83 11.83 0 0 0-9.59-4.28h-7.74z"
      fill={props.color ? props.color : '#fff'}
    />
  </svg>
)

let isIE = false
if (
  (typeof navigator != 'undefined' &&
    navigator.appName == 'Microsoft Internet Explorer') ||
  !!(
    typeof navigator != 'undefined' &&
    (navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/rv:11/))
  ) ||
  (typeof $ !== 'undefined' &&
    typeof $.browser !== 'undefined' &&
    $.browser.msie == 1)
) {
  isIE = true
}

export default (isIE ? ieIMRD : IMRD)



// WEBPACK FOOTER //
// ./src/components/shared/imrd.js